import { reduxActions } from '../constants';

export function growlList(state = [], action) {
    switch (action.type) {
        case reduxActions.ADD_GROWL:
            return [
                ...state,
                Object.assign({}, action.growl, {
                    growlId: action.growlId
                })
            ];
        case reduxActions.REMOVE_GROWL:
            return state.filter((item) => {
                if (item.growlId === action.growlId) {
                    if (item.timeout !== -1) {
                        clearTimeout(item.timeout);
                    }
                    return false;
                }
                return true;
            });
        case reduxActions.DELAY_GROWL:
            return state.map(item => {
                if (item.timeout != -1 && item.growlId === action.growlId) {
                    clearTimeout(item.timeout);
                    return Object.assign({}, item, {
                        timeout: -1
                    });
                } else {
                    return item;
                }
            });
        case reduxActions.REMOVE_ALL_GROWLS:
            return [];
        default:
            return state;
    }
}

export function nextGrowlId(state = 0, action) {
    switch (action.type) {
        case reduxActions.ADD_GROWL:
            return state + 1;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./web-app/reducers/growl-reducer.js